import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export const getSettings = (params: any) => api.get(url.GET_SETTINGS, params);

export const updateSetting = (data: any) =>
  api.put(url.UPDATE_SETTING + "/" + data.id, data);
